import React from 'react';

const DateTimeDisplay = ({ value, type, isDanger }) => {
  //<span>{type}</span>
  return (
    <div className={isDanger ? 'countdown danger' : 'countdown'}>
      <p> ({value}วินาที)</p>
    </div>
  );
};

export default DateTimeDisplay;
